module.exports = __webpack_public_path__ + "media/pling.5e0a5ea2.ogg";